import { combineReducers } from 'redux';
import {
    GET_SAVED_ELEMENT_SUCCESS,
    GET_SAVED_ELEMENT_REQUEST,
    GET_PROVIDED_ELEMENT_SUCCESS,
    GET_PROVIDED_ELEMENT_REQUEST,
    REMOVE_ELEMENT_SUCCESS,
} from '../actionTypes';

const byId = (state = {}, action) => {
    if (!action) return state;

    switch (action.type) {
        case GET_SAVED_ELEMENT_SUCCESS:
        case GET_PROVIDED_ELEMENT_SUCCESS: {
            const nextState = { ...state };
            action.elements.forEach((el) => {
                const { id, data, ...rest } = el;
                nextState[id] = { ...rest, id };
            });
            return nextState;
        }

        case REMOVE_ELEMENT_SUCCESS: {
            const nextState = { ...state };
            delete nextState[action.id];
            return nextState;
        }
        default:
            return state;
    }
};

const createList = (filter) => {
    const ids = (state = [], action) => {
        if (
            filter.isPrivate !== action.isPrivate ||
            filter.type !== action.filter
        ) {
            return state;
        }

        switch (action.type) {
            case GET_SAVED_ELEMENT_SUCCESS:
            case GET_PROVIDED_ELEMENT_SUCCESS: {
                return action.elements.map((el) => el.id);
            }

            default:
                return state;
        }
    };
    const isFetching = (state = false, action) => {
        if (
            filter.isPrivate !== action.isPrivate ||
            filter.type !== action.filter
        ) {
            return state;
        }
        switch (action.type) {
            case GET_SAVED_ELEMENT_REQUEST:
            case GET_PROVIDED_ELEMENT_REQUEST: {
                return true;
            }
            case GET_SAVED_ELEMENT_SUCCESS:
            case GET_PROVIDED_ELEMENT_SUCCESS: {
                return false;
            }
            default:
                return state;
        }
    };

    return combineReducers({ ids, isFetching });
};

const listByFilter = combineReducers({
    providedRows: createList({ type: 'ROW', isPrivate: false }),
    providedColumns: createList({ type: 'COLUMN', isPrivate: false }),
    providedSections: createList({ type: 'SECTION', isPrivate: false }),
    providedElements: createList({ type: 'ELEMENT', isPrivate: false }),
    savedRows: createList({ type: 'ROW', isPrivate: true }),
    savedColumns: createList({ type: 'COLUMN', isPrivate: true }),
    savedSections: createList({ type: 'SECTION', isPrivate: true }),
    savedElements: createList({ type: 'ELEMENT', isPrivate: true }),
});

export default combineReducers({ byId, listByFilter });

export const getVisibleElements = (state, listKey) => {
    const ids = state.listByFilter[listKey].ids;
    return ids.map((id) => state.byId[id]).filter((v) => v);
};

export const getIsFetchingElements = (state, listKey) => {
    return state.listByFilter[listKey].isFetching;
};
